<cc-lg-chart
  [useLegend]="false"
  [chartType]="'horizontalBar'"
  [chartsData]="chartsData"
  [options]="barChartOptions"
>

</cc-lg-chart>
